import { forwardRef, type ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
  gap?: string;
}

export const PageContainer = forwardRef<HTMLDivElement, PageContainerProps>(
  function PageContainer({ children, gap }, ref) {
    return (
      <div
        ref={ref}
        className="stack"
        style={{ '--stack-gap': gap ?? 'var(--space-5)' } as React.CSSProperties}
      >
        {children}
      </div>
    );
  },
);
